import {CartEmpty} from 'modules/Cart/components/CartEmpty/CartEmpty';
import {CartOrderLayout} from 'modules/Cart/containers/CartOrderLayout/CartOrderLayout';
import {useCartContext} from 'modules/Cart/contexts/cartContext';
import {FC} from 'react';

type Props = {};
export const CartOffer: FC<Props> = () => {
    const {productsIds, isReady} = useCartContext();
    const cartIsEmpty = !productsIds.length;

    if (!isReady) {
        return null;
    }

    if (cartIsEmpty) {
        return <CartEmpty />;
    }

    return (
        <div>
            <CartOrderLayout />

            {/* <RelatedProducts /> */}
        </div>
    );
};
